import network from './network'

let ONAMEdata = []
let ONAMEaxios = async() => {
  await network.findObjectNameurl({})
    .then((response) => {
      // console.log(response.data.info);
      ONAMEdata = response.data.info
    })
}
let RISK_UNIT_NAMEdata = []
let RISK_UNIT_NAMEaxios = async() => {
  let data = []
  await network.findUnitNameurl({})
    .then((response) => {
      // console.log(response.data.info);
      RISK_UNIT_NAMEdata = response.data.info
    })
}
// ONAMEaxios()
// RISK_UNIT_NAMEaxios()
let ONAMEreturn = () => { // 风险分析对象
  return ONAMEdata
}
let RISK_UNIT_NAMEreturn = () => { // 风险分析单元
  return RISK_UNIT_NAMEdata
}
export default {
  yhpczlOIFRISK: () => { // 是否重大危险源
    return [
      { name: '是', code: 0 },
      { name: '否', code: 1 }
    ]
  },
  yhpczlOIFRISKS: () => { // 排查进度
    return [
      { name: '待排查', code: 0 },
      { name: '待审核', code: 1 },
      { name: '待确认', code: 2 },
      { name: '待治理', code: 3 },
      { name: '待验收', code: 4 },
      { name: '完成', code: 5 },
      { name: '驳回', code: 6 },
      { name: '超期', code: 7 }

    ]
  },
  yhpczlIFSTAR: () => { // 是否启用
    return [
      { name: '是', code: 0 },
      { name: '否', code: 1 }
    ]
  },
  yhpczlDANGER_LEVEL: () => { // 隐患等级
    return [
      { name: '一般隐患', code: 0 },
      { name: '重大隐患', code: 1 }
    ]
  },
  yhpczlDANGER_SRC: () => { // 隐患来源
    return [
      { name: '日常排查', code: 1 },
      { name: '综合性排查', code: 2 },
      { name: '专业性排查', code: 3 },
      { name: '季节性排查', code: 4 },
      { name: '重点时段及节假日前排查', code: 5 },
      { name: '事故类比排查', code: 6 },
      { name: '复产复工前排查', code: 7 },
      { name: '外聘专家诊断式排查', code: 8 },
      { name: '管控措施失效', code: 9 },
      { name: '其他', code: 10 }
    ]
  },
  HAZARD_DANGER_TYPE: () => { // 隐患类型
    return [
      { name: '安全', code: 1 },
      { name: '工艺', code: 2 },
      { name: '电气', code: 3 },
      { name: '仪表', code: 4 },
      { name: '消防', code: 5 },
      { name: '总图', code: 6 },
      { name: '设备', code: 7 },
      { name: '其他', code: 8 }
    ]
  },
  yhpczlRESULT: () => { // 排查结果
    return [
      { name: '正常', code: 0 },
      { name: '存在隐患', code: 1 },
      { name: '未排查', code: 2 },
      { name: '其他', code: 3 }
    ]
  },
  yhpczlEXECUTION_STATUS: () => { // 隐患来源
    return [
      { name: '通过', code: 3 },
      { name: '未通过', code: 2 }
    ]
  },
  yhpczlZTYPE: () => { // 隐患治理类型
    return [
      { name: '即查即改', code: 0 },
      { name: '限期整改', code: 1 }
    ]
  },
  yhpczlshzt: () => { // 隐患延期审核 审核状态
    return [
      { name: '审核未通过', code: 0 },
      { name: '限期整改', code: 1 }
    ]
  },
  yhpcshAdd: () => { // 隐患延期审核 审核状态
    return [
      { name: '通过', code: 2 },
      { name: '不通过', code: 1 }
    ]
  },
  yhpcIF_TRUE: () => { // 隐患验收 是否合格
    return [
      { name: '是', code: 0 },
      { name: '否', code: 1 }
    ]
  },
  yhpczlCHECK_CYCLE_UNIT: () => { // 巡检周期
    return ['小时', '天', '月', '年']
  },
  ONAMEreturn, // 风险分析对象
  RISK_UNIT_NAMEreturn // 风险分析单元

}



// WEBPACK FOOTER //
// ./src/api/yhpc.js